export default __webpack_public_path__ + "6adace307e9696b1a06fc7e301561232.svg";